
jQuery(function()
{
     initScrollReveal();
     initFAQeffect();
     initSmoothScrollToAnchor();
     initUnderlineNav();
     initStartVisit();
     initContactForm();
     trackPhoneClick();
});

function initScrollReveal() {
  // Changing the defaults
  window.sr = ScrollReveal({reset:false});
  // Customizing a reveal set
  sr.reveal('.img, .icon-circle-right', {scale: 1,duration:500});
  sr.reveal('.team, .box-service, .box-service h1, .sponsor', { scale:1, duration: 300 }, 100);
  sr.reveal('.box-service ul li', { scale:1, duration: 500, delay: 700 }, 50);
  sr.reveal('.content-orbit-slide ul li', { scale:1, duration: 500}, 50);
  sr.reveal('.box-service .button', { scale:1, duration: 500, delay: 2000 }, 50);
  sr.reveal('h2.align-middle', { scale:1, duration: 500 }, 200);
  // sr.reveal('p', { scale:1, duration: 1000, delay: 600} );
}

function trackPhoneClick() {
  jQuery('.phone').on('click', function() {
    ga('send', 'event', 'Contact us', 'click', 'Phone');
  });
  jQuery('.emergency').on('click', function() {
    ga('send', 'event', 'Contact us', 'click', 'Emergency');
  });
}
function initStartVisit()
{
  jQuery( '.cta-form' ).submit(function(e)
  {
      var form = jQuery(this);
      var reason = form.find(jQuery('select[name="visitor_reason"]')).val();
      var name =  form.find(jQuery('input[name="visitor_name"]')).val();
      var phone = form.find(jQuery('input[name="visitor_phone"]')).val();
      var email = form.find(jQuery('input[name="visitor_email"]')).val();
      var modal = jQuery('#thanks-you-modal');

      ga('send', 'event', 'Book an appointment', 'submit', reason);

  		jQuery.ajax({
  			url:form.attr('action'),
  			data : {
  					action : 'start_plan_a_visit',
            "visitor_reason" : reason,
            "visitor_name" : name,
            "visitor_phone" : phone,
            "visitor_email" : email
  			},
  			type:form.attr('method'),

  			beforeSend:function(xhr){
  				  modal.html('');
  			},
  			error: function(e) {
  				console.log(e);
  			},
  			success:function(data) {
          modal.html( data ).foundation('open');
  			}
  		});

  		e.preventDefault();
  		return false;
  });
}
function initContactForm()
{
  jQuery( '.formulaire_contact' ).submit(function(e) {
      var form = jQuery(this);
      var name =  form.find(jQuery('input[name="contact_name"]')).val();
      var email = form.find(jQuery('input[name="contact_email"]')).val();
      var message = form.find(jQuery('textarea')).val();
      var response = form.find(jQuery('.response'));

      ga('send', 'event', 'Contact us', 'submit', 'Form');

      jQuery.ajax({

        url:form.attr('action'),
        data : {
            action : 'contact_pasadora',
            "contact_name" : name,
            "contact_email" : email,
            "contact_message" : message
        },
        type:form.attr('method'),

        beforeSend:function(xhr){
            response.html('');
        },
        error: function(e) {
          console.log(e);
        },
        success:function(data) {
          response.html( data );
        }
      });

      e.preventDefault();
      return false;
  });
}
function initSmoothScrollToAnchor()
{
  // Select all links with hashes
jQuery('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = jQuery(this.hash);
      target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        jQuery('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
        });
      }
    }
  });
}
function initFAQeffect()
{
  jQuery('.accordion-header').click(function () {

    jQuery(this).children('.arrow').toggleClass('active');
    jQuery(this).parent().siblings().children('.accordion-header').children('.arrow').removeClass('active');
    jQuery(this).next('.accordion-body').slideToggle('fast').toggleClass('active');
    jQuery(this).parent().siblings().children('.accordion-body').slideUp('fast');

   });

}
function initUnderlineNav()
{
  var j$ = jQuery,
      $nav = j$(".navigation"),
      $slideLine = j$("#slide-line"),
      $currentItem = j$(".navigation .current-menu-item");

  j$(function(){
    // Menu has active item
    if ($currentItem[0]) {
      $slideLine.css({
        "width": $currentItem.width(),
        "left": $currentItem.position().left
      });
    }
    // Underline transition
    j$($nav).find("li").hover(
      // Hover on
      function(){
        $slideLine.css({
          "width": j$(this).width(),
          "left": j$(this).position().left
        });
      },
      // Hover out
      function(){
        if ($currentItem[0]) {
          // Go back to current
          $slideLine.css({
            "width": $currentItem.width(),
            "left": $currentItem.position().left
          });
        } else {
          // Disapear
          $slideLine.width(0);
        }
      }
     );
  });
}
